var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-table__cell hide-mobile",class:[_vm.cell.prop, _vm.cell.propType,]},[_c('div',{staticClass:"app-table__cell-content"},[_vm._v(" "+_vm._s(_vm.printedValue)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }